import PartData from './PartData';
export default PartData;